<div class="trip-track" id="trip-vehicle-track" [class.compact]="compact">
  <div class="trip-track-bar" id="trip-track-controls">
    <button type="button" id="track-play" (click)="toggle()" [disabled]="points.length < 2">{{ playing ? "Pause" : "Play" }}</button>
    @for (rate of speeds; track rate) {
    <button type="button" [id]="'track-speed-' + rate" [class.active]="speed === rate" (click)="setSpeed(rate)">{{ rate }}×</button>
    }
    <span id="track-clock">{{ clock() }}</span>
    <span id="track-speed-now">{{ speedText() }}</span>
    <span class="track-note">{{ loading ? "Loading the driver's GPS trail…" : note }}</span>
  </div>
  @if (points.length > 1) {
  <div class="trip-timeline" id="track-timeline">
    <input id="track-scrub" type="range" [min]="spanStart" [max]="spanEnd" step="1000" [value]="playhead" (input)="onScrub($event)" aria-label="Trip time" />
    <div class="trip-event-row">
      @for (event of events; track event.id; let i = $index) {
      <button type="button" class="trip-event" [class.low]="i % 2 === 1" [id]="'track-event-' + event.id" [style.left.%]="eventPercent(event)" (click)="jumpTo(event)" [attr.aria-label]="event.label + ' ' + formatClock(event.time)" [title]="event.label + ' ' + formatClock(event.time)">{{ event.label }}</button>
      }
    </div>
  </div>
  }

  @if (mapMode === "plot") {
  <div class="trip-track-plot" id="trip-track-plot">
    <svg viewBox="0 0 1000 600" (mousemove)="onPlotMove($event)" (mouseleave)="hover = ''">
      <polyline [attr.points]="trailSvg()" fill="none" stroke="#0f766e" stroke-width="4" stroke-linejoin="round" stroke-linecap="round" />
      <polyline [attr.points]="playedSvg()" fill="none" stroke="#115e59" stroke-width="6" stroke-linejoin="round" stroke-linecap="round" />
      @if (markerSvg(pickup); as pin) {
      <circle class="pin pickup" [attr.cx]="pin.x" [attr.cy]="pin.y" r="16" />
      <text [attr.x]="pin.x" [attr.y]="pin.y + 5">A</text>
      }
      @if (markerSvg(drop); as pin) {
      <circle class="pin drop" [attr.cx]="pin.x" [attr.cy]="pin.y" r="16" />
      <text [attr.x]="pin.x" [attr.y]="pin.y + 5">B</text>
      }
      @if (markerSvg(car); as pin) {
      <circle id="track-car" class="cursor" [attr.cx]="pin.x" [attr.cy]="pin.y" r="8" />
      }
    </svg>
    <p id="track-hover">{{ hover || "Hover the trail for the time" }}</p>
  </div>
  } @else if (mapMode === "google" || mapMode === "mapbox") {
  <div [id]="mapElementId" class="trip-track-map"></div>
  }
</div>
